import React from "react";
import Thumbnail from "./ui/Thumbnail";

/** @deprecated Prefer Thumbnail from components/ui */
export default function ProfileThumbnail(props) {
  return <Thumbnail {...props} />;
}
